import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { rxResource } from "@angular/core/rxjs-interop";
import { catchError, map, of } from "rxjs";
import { ApiService } from "../core/api.service";
import { Settings } from "../core/models";

@Component({
  selector: "app-terms-settings-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, RouterModule],
  templateUrl: "./terms-settings-page.component.html",
  styleUrls: ["./settings-form-page.component.scss"],
})
export class TermsSettingsPageComponent {
  private readonly api = inject(ApiService);

  terms: string[] = [];

  readonly saving = signal(false);
  readonly message = signal("");

  private readonly settingsResource = rxResource({
    stream: () =>
      this.api.getSettings().pipe(
        map((settings) => {
          this.terms = [...(settings.terms ?? [])];
          return settings;
        }),
        catchError(() => {
          this.message.set("Failed to load settings.");
          return of(null);
        }),
      ),
  });

  save() {
    this.saving.set(true);
    this.api.updateSettings({ terms: this.terms }).subscribe({
      next: (settings) => {
        this.terms = [...(settings.terms ?? [])];
        this.message.set("Terms saved.");
        this.saving.set(false);
      },
      error: () => {
        this.message.set("Failed to save terms.");
        this.saving.set(false);
      },
    });
  }

  addTerm() {
    this.terms.push("");
  }

  removeTerm(index: number) {
    this.terms.splice(index, 1);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
